<script lang="ts">
    import InstallGlobalKeyboardEventsOnWindow from "./Initialization/InstallGlobalKeyboardEventsOnWindow.svelte";
    import InstallKeyboardWidget from "./Initialization/InstallKeyboardWidget.svelte";
    import InstallMainSearchInputEvents from "./Initialization/InstallMainSearchInputEvents.svelte";
    import InstallSidebarWordlist from "./Initialization/InstallSidebarWordlist.svelte";
    import InstallWordlistActiveItemManagement from "./Initialization/InstallWordlistActiveItemManagement.svelte";
    import SearchWidget from "./SearchWidget.svelte";

    const dictionarySearchInput = document.getElementById(
        "dictionary-search"
    ) as HTMLInputElement;
    const searchWidgetContainer = document.getElementById(
        "search-container"
    ) as HTMLDivElement;

</script>

{#if dictionarySearchInput}
    <InstallWordlistActiveItemManagement {dictionarySearchInput} />
    <InstallKeyboardWidget {dictionarySearchInput} />
    <SearchWidget />
    <InstallGlobalKeyboardEventsOnWindow {dictionarySearchInput} />
    {#if searchWidgetContainer}
        <InstallMainSearchInputEvents
            {dictionarySearchInput}
            {searchWidgetContainer}
        />
    {/if}
{/if}
<InstallSidebarWordlist />
